import React from 'react'
import { Row } from 'react-bootstrap'

import { PopAvatar } from '../../../components/avatar'

const Experience = () => (
  <Row className='social justify-center'>
    <PopAvatar
      path='https://i.pinimg.com/736x/5b/59/f4/5b59f4c5a4df1f00a482a11a3d4880f8--github-logo-labs.jpg'
      style={{ margin: 10 }}
      tipText='Github'
      type='sm'
    />
    <PopAvatar
      path='https://d2vqpl3tx84ay5.cloudfront.net/500x/tumblr_lsus01g1ik1qies3uo1_400.png'
      style={{ margin: 10 }}
      tipText='Javascript'
      type='sm'
    />
    <PopAvatar
      path='http://www.technoscore.com/images/services/react-js-icon.png'
      style={{ margin: 10 }}
      tipText='React JS'
      type='sm'
    />
    <PopAvatar
      path='https://www.valentinog.com/blog/wp-content/uploads/2017/12/redux-logo.png'
      style={{ margin: 10 }}
      tipText='Redux'
      type='sm'
    />
    <PopAvatar
      path='http://drupal.sh/sites/default/files/styles/large/public/2016-06/graphql.jpg?itok=bAWB8IYo'
      style={{ margin: 10 }}
      tipText='Graphql'
      type='sm'
    />
    <PopAvatar
      path='https://sass-lang.com/assets/img/styleguide/seal-color-aef0354c.png'
      style={{ margin: 10 }}
      tipText='Sass'
      type='sm'
    />
    <PopAvatar
      path='https://seeklogo.com/images/Y/yarn-logo-F5E7A65FA2-seeklogo.com.png'
      style={{ margin: 10 }}
      tipText='Yarn'
      type='sm'
    />
    <PopAvatar
      path='http://codecollege.co.za/wp-content/uploads/2016/08/nodejs-1.png'
      style={{ margin: 10 }}
      tipText='Node JS'
      type='sm'
    />
    <PopAvatar
      path='https://cacm.acm.org/system/assets/0002/7119/042117_Theodo_MongoDB.large.jpg?1492791427&1492791427'
      style={{ margin: 10 }}
      tipText='Mongodb'
      type='sm'
    />
    <PopAvatar
      path='https://pbs.twimg.com/profile_images/733010550670557184/aMmM_m3g.jpg'
      style={{ margin: 10 }}
      tipText='Google Firebase'
      type='sm'
    />
    <PopAvatar
      path='https://www.3pillarglobal.com/wp-content/uploads/2015/11/xselenium_logo_320x260-300x260.jpg.pagespeed.ic.aqA1rifk_N.jpg'
      style={{ margin: 10 }}
      tipText='Selenium Web Driver'
      type='sm'
    />
    <PopAvatar
      path='https://avatars3.githubusercontent.com/u/28507035?s=400&v=4'
      style={{ margin: 10 }}
      tipText='Nest JS'
      type='sm'
    />
    <PopAvatar
      path='http://www.blondenerd.com/wp-content/uploads/2012/02/halo-21.jpg'
      style={{ margin: 10 }}
      tipText='Halo 2'
      type='sm'
    />
    <PopAvatar
      path='https://ih1.redbubble.net/image.231864847.1593/flat,800x800,075,f.u10.jpg'
      style={{ margin: 10 }}
      tipText='Photoshop'
      type='sm'
    />
    <PopAvatar
      path='https://pbs.twimg.com/profile_images/821713465245102080/mMtKIMax_400x400.jpg'
      style={{ margin: 10 }}
      tipText='Jest'
      type='sm'
    />
    <PopAvatar
      path='http://www.betazedsoftwaresolutionsinc.com/assets/images/shields/postgres.png'
      style={{ margin: 10 }}
      tipText='Postgresql'
      type='sm'
    />
    <PopAvatar
      path='http://imgf.downloadapk.net/f/73/b71075_150.png'
      style={{ margin: 10 }}
      tipText='Expo'
      type='sm'
    />
  </Row>
)

export default Experience



// WEBPACK FOOTER //
// ./src/core/profile/experience/index.js